import { render, staticRenderFns } from "./QRCODE.vue?vue&type=template&id=08ed1738&scoped=true&"
import script from "./QRCODE.vue?vue&type=script&lang=js&"
export * from "./QRCODE.vue?vue&type=script&lang=js&"
import style0 from "./QRCODE.vue?vue&type=style&index=0&id=08ed1738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed1738",
  null
  
)

export default component.exports